import Dashboard from './Dashboard'

export const dashboardRoutes = [
  { path: '/', redirect: 'dashboard' },
  { name: 'dashboard', path: '/dashboard', component: Dashboard }
]
